import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { QR_QUIET_ZONE_MODULES, buildQrCode } from './qr-code.util';

/**
 * Renders a QR code as inline SVG.
 *
 * Replaces `angularx-qrcode` (+ its CommonJS `qrcode` dependency, which dragged `dijkstrajs`,
 * `pngjs` and `yargs` into the browser bundle) with `uqr` — ESM, zero dependencies. The encoding
 * parameters in `qr-code.util.ts` match the defaults of the component this replaced, so an existing
 * payload produces the same symbol.
 *
 * `data` is the payload to ENCODE, not an image URL — the sole caller (the 2FA enrolment wizard)
 * passes the `otpauth://totp/...` URI the server builds. It is undefined while the setup request is
 * in flight, so empty input renders nothing rather than throwing.
 */
@Component({
    selector: 'ft-qr-code',
    standalone: true,
    templateUrl: './qr-code.component.html',
    styleUrl: './qr-code.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FtQrCodeComponent {
    /** Payload to encode. Empty / null / undefined renders nothing. */
    readonly data = input<string | null | undefined>();
    /** Rendered edge length in CSS pixels. The symbol scales via `viewBox`, so this is free. */
    readonly size = input(200);
    /** Quiet-zone width in modules. Below 4 many scanners will not lock on — see the util. */
    readonly quietZone = input(QR_QUIET_ZONE_MODULES);
    /** Accessible name; the payload itself is meaningless read aloud. */
    readonly ariaLabel = input('QR code');

    protected readonly qrCode = computed(() => buildQrCode(this.data(), this.quietZone()));
}
